import axios from "../axios";

const auth = async function (accessToken,params) {
    try {
        const response = await axios.post('/bank-account/auth', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        const data = e.response?.data;
        return {
            success: false,
            message: data?.message || e.message || 'Không thể kết nối máy chủ',
            errorCode: e.response?.status,
        };
    }
}

export default auth;
